import React from "react";

import HomeHero from "./HomeHero";

import HomeContent from "./HomeContent";
import Seo, {
  breadcrumbSchema,
  faqSchema,
  organizationSchema,
  privateLabelServiceSchema,
  websiteSchema,
} from "../Seo/Seo";

const homeFaqs = [
  {
    question: "What is Klean Leaf?",
    answer:
      "Klean Leaf is a Columbus, Ohio based B2B private-label laundry detergent sheet manufacturer helping brands launch custom laundry sheet products.",
  },
  {
    question: "What does Klean Leaf manufacture?",
    answer:
      "Klean Leaf manufactures laundry detergent sheets for private-label, wholesale, refill shop, retail, e-commerce, and distributor programs.",
  },
  {
    question: "Who does Klean Leaf help?",
    answer:
      "Klean Leaf helps brands, wholesalers, refill shops, e-commerce brands, subscription brands, retailers, distributors, and eco-home product companies.",
  },
  {
    question: "What is the MOQ for private label laundry detergent sheets?",
    answer:
      "For retail packaged products, MOQ starts at 1,000 units per SKU. Bulk refill cartons are available separately for refill shops and wholesale programs.",
  },
  {
    question: "Can I customize packaging for my brand?",
    answer:
      "Yes. Klean Leaf supports paper bags, paper boxes, custom packaging, and bulk refill cartons for business buyers.",
  },
  {
    question: "Can customers choose fragrance-free or scented formulas?",
    answer:
      "Yes. Buyers can choose fragrance-free formulas, review scent samples, or discuss custom scent and formula development.",
  },
  {
    question: "Do you provide samples?",
    answer:
      "Yes. Sample support is available from the Columbus, Ohio office so buyers can review sheet performance, scent, and packaging direction.",
  },
  {
    question: "What documents or testing support are available?",
    answer:
      "Available documentation can include ISO 9001, ISO 22716 GMP, OECD 301B, MSDS, and optional third-party testing support.",
  },
  {
    question: "What is the production lead time?",
    answer:
      "Typical production lead time is around 35 to 45 days after order confirmation, depending on packaging, formula, testing, and logistics requirements.",
  },
];


function Home() {
  return (
    <>
    <Seo
      title="Laundry Detergent Sheets Manufacturer | Klean Leaf"
      description="Launch private label laundry sheets with Klean Leaf. Custom formula, scent, packaging, bulk production, samples, and logistics support."
      path="/"
      schema={[
        organizationSchema,
        websiteSchema,
        privateLabelServiceSchema,
        breadcrumbSchema([{ name: "Home", path: "/" }]),
        faqSchema(homeFaqs),
      ]}
    />
    <HomeHero />
    <HomeContent />
    </>
  );
}

export default Home;
